import { cn } from '@/lib/utils';
import type { UserAccountType } from '@/constants/rbac';

type UserTypeToggleProps = {
  value: UserAccountType;
  onChange: (_value: UserAccountType) => void;
  disabled?: boolean;
};

export const UserTypeToggle = ({ value, onChange, disabled }: UserTypeToggleProps) => (
  <div
    className={cn(
      'grid grid-cols-2 rounded-lg bg-gray-100 p-1',
      disabled && 'pointer-events-none opacity-70'
    )}
  >
    <button
      type="button"
      disabled={disabled}
      onClick={() => onChange('COLLABORATOR')}
      className={cn(
        'h-9 rounded-md text-sm font-medium transition-colors',
        value === 'COLLABORATOR' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600',
        disabled && 'cursor-not-allowed'
      )}
    >
      Colaborador
    </button>
    <button
      type="button"
      disabled={disabled}
      onClick={() => onChange('CLIENT')}
      className={cn(
        'h-9 rounded-md text-sm font-medium transition-colors',
        value === 'CLIENT' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600',
        disabled && 'cursor-not-allowed'
      )}
    >
      Cliente
    </button>
  </div>
);
